import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'lib/store';

export interface PlanSelection {
  selectedPlans: string[];
}

export const initialState: PlanSelection = {
  selectedPlans: [],
};

const planSelectionSlice = createSlice({
  initialState,
  name: 'planSelection',
  reducers: {
    addPlanSelection: (state, action) => {
      return {
        ...state,
        selectedPlans: action.payload,
      };
    },
    removePlanSelection: (state, action) => {
      return {
        ...state,
        selectedPlans: state.selectedPlans.filter(
          (id) => id !== action.payload
        ),
      };
    },
  },
});

const { actions, reducer } = planSelectionSlice;

export const { addPlanSelection, removePlanSelection } = actions;

export const selectPlanSelection = (state: RootState) =>
  state.planSelection.selectedPlans;

export default reducer;
